export enum ExternalTransfersDialogs {
  CONFIRM = 'confirm',
  FAVORITE = 'favorite',
  LINK_EXTERNAL_ACCOUNT = 'linkExternalAccount',
  EXPIRED_SYNC = 'expiredSync'
}
